package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String

public class MerchantLocationQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> getAllLocations(mapper: (
    merchantKey: String,
    categoryId: String,
    subcategoryText: String?,
    latitude: Double,
    longitude: Double,
    visitCount: Long,
    lastVisitedEpochMs: Long,
  ) -> T): Query<T> = Query(-858_467_775, arrayOf("MerchantLocationEntity"), driver,
      "MerchantLocation.sq", "getAllLocations",
      "SELECT MerchantLocationEntity.merchantKey, MerchantLocationEntity.categoryId, MerchantLocationEntity.subcategoryText, MerchantLocationEntity.latitude, MerchantLocationEntity.longitude, MerchantLocationEntity.visitCount, MerchantLocationEntity.lastVisitedEpochMs FROM MerchantLocationEntity") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getDouble(3)!!,
      cursor.getDouble(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!
    )
  }

  public fun getAllLocations(): Query<MerchantLocationEntity> = getAllLocations { merchantKey,
      categoryId, subcategoryText, latitude, longitude, visitCount, lastVisitedEpochMs ->
    MerchantLocationEntity(
      merchantKey,
      categoryId,
      subcategoryText,
      latitude,
      longitude,
      visitCount,
      lastVisitedEpochMs
    )
  }

  public fun <T : Any> getLocationByMerchant(merchantKey: String, mapper: (
    merchantKey: String,
    categoryId: String,
    subcategoryText: String?,
    latitude: Double,
    longitude: Double,
    visitCount: Long,
    lastVisitedEpochMs: Long,
  ) -> T): Query<T> = GetLocationByMerchantQuery(merchantKey) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getDouble(3)!!,
      cursor.getDouble(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!
    )
  }

  public fun getLocationByMerchant(merchantKey: String): Query<MerchantLocationEntity> =
      getLocationByMerchant(merchantKey) { merchantKey_, categoryId, subcategoryText, latitude,
      longitude, visitCount, lastVisitedEpochMs ->
    MerchantLocationEntity(
      merchantKey_,
      categoryId,
      subcategoryText,
      latitude,
      longitude,
      visitCount,
      lastVisitedEpochMs
    )
  }

  public suspend fun insertOrUpdate(
    merchantKey: String,
    categoryId: String,
    subcategoryText: String?,
    latitude: Double,
    longitude: Double,
    visitCount: Long,
    lastVisitedEpochMs: Long,
  ) {
    driver.execute(-848_591_977, """
        |INSERT OR REPLACE INTO MerchantLocationEntity(merchantKey, categoryId, subcategoryText, latitude, longitude, visitCount, lastVisitedEpochMs)
        |VALUES (?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 7) {
          bindString(0, merchantKey)
          bindString(1, categoryId)
          bindString(2, subcategoryText)
          bindDouble(3, latitude)
          bindDouble(4, longitude)
          bindLong(5, visitCount)
          bindLong(6, lastVisitedEpochMs)
        }.await()
    notifyQueries(-848_591_977) { emit ->
      emit("MerchantLocationEntity")
    }
  }

  private inner class GetLocationByMerchantQuery<out T : Any>(
    public val merchantKey: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("MerchantLocationEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("MerchantLocationEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-3_019_432,
        """SELECT MerchantLocationEntity.merchantKey, MerchantLocationEntity.categoryId, MerchantLocationEntity.subcategoryText, MerchantLocationEntity.latitude, MerchantLocationEntity.longitude, MerchantLocationEntity.visitCount, MerchantLocationEntity.lastVisitedEpochMs FROM MerchantLocationEntity WHERE merchantKey = ? LIMIT 1""",
        mapper, 1) {
      bindString(0, merchantKey)
    }

    override fun toString(): String = "MerchantLocation.sq:getLocationByMerchant"
  }
}
